<template>
  <div :class="{ clickableList: clickable }" ref="treeData"></div>
</template>

<script>
import clean from 'lodash-clean';

export default {
  name: 'TreeStructure',
  data() {
    return {};
  },
  props: {
    flatData: {
      type: Array,
      required: true,
    },
    separator: {
      type: String,
      default: '|',
    },
    clickable: Boolean,
  },
  mounted() {
    this.createTree(this.$refs.treeData, this.getFlatStructureAsTree(this.flatData));
  },
  methods: {
    clickTreeItem(item) {
      if (!this.clickable) {
        return;
      }
      const newItem = {...item, type: 'category'};
      this.$emit('clickTreeItem', newItem);
    },
    getFlatStructureAsTree(flatDataArray) {
      let currentPath;
      let lastPath;
      let node;
      let parent;
      const map = {
        '': {
          children: [],
        },
      };
      let stack = [''];

      for (let i = 0; i < flatDataArray.length; i += 1) {
        const nodes = flatDataArray[i].split(this.separator);
        for (let j = 0; j < nodes.length; j += 1) {
          currentPath = `${nodes.slice(0, j + 1).join(this.separator)}`;
          const name = nodes[j];
          lastPath = stack[stack.length - 1];
          parent = map[lastPath];

          if (!map[currentPath]) {
            node = {
              id: currentPath,
              label: name,
              children: [],
            };
            parent.children.push(node);
            map[currentPath] = node;
          }
          stack.push(currentPath);
        }
        stack = stack.slice(0, 1);
      }
      return flatDataArray.length === 0 ? [] : clean(map[''].children);
    },
    createTree(container, treeDataArray) {
      const ul = container.appendChild(document.createElement('ul'));
      Object.entries(treeDataArray).forEach((entry) => {
        const [key, val] = entry;
        const li = ul.appendChild(document.createElement('li'));
        li.textContent = val.label;
        if (val.children) {
          li.textContent = val.label;
          this.createTree(li, val.children);
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.clickableList li {
  cursor: pointer;

  span:hover {
    text-decoration: underline;
  }
}
</style>
